export const LegalPersonalityCode = Object.freeze({
    FO: "FO", // fyzicka osoba - personal entity
    PO: "PO", // pravnicka osoba - legal entity
});
